import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import activityLogService from "@/services/mrfiktiv/services/activityLogService";
import { MrfiktivActivityLogViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module, Mutation } from "vuex-module-decorators";
import {
  MrfiktivActivityLogControllerFindAllParamsGen,
  MrfiktivCreateActivityLogDtoGen,
  MrfiktivUpdateActivityLogDtoGen
} from "./../../services/mrfiktiv/v1/data-contracts";
import { BasePagination, FilterTypes, IPaginationFilterListElement } from "./base-pagination.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "activity-log",
  store
})
export class ActivityLogStore extends BasePagination<
  MrfiktivActivityLogViewModelGen,
  MrfiktivActivityLogControllerFindAllParamsGen
> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 1000;
  protected _totalPages = 0;
  protected _paginationList: MrfiktivActivityLogViewModelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = true;
  protected _filterList: IPaginationFilterListElement[] = [{ key: "partnerId", type: FilterTypes.OBJECT_ID }];

  _activityLog: MrfiktivActivityLogViewModelGen = {} as any;

  get activityLogs() {
    return this._paginationList;
  }

  @Action
  protected async loadDocuments(query: MrfiktivActivityLogControllerFindAllParamsGen): Promise<any> {
    return activityLogService.getAllForPartner(query);
  }

  @Action
  async loadDocumentsForReport(data: { partnerId: string; reportId: string }): Promise<any> {
    const reportActivities = await activityLogService.getAllByReportForPartner(data.partnerId, data.reportId);

    this.context.commit("mutateDocuments", reportActivities.data);

    return reportActivities;
  }

  @Action
  async getAll(data: { partnerId: string }) {
    await this.fetchAllFromBeginning({
      partnerId: data.partnerId
    });

    this.context.commit("mutateDocuments", this._paginationList);
  }

  @Mutation
  mutateActivityLog(request: MrfiktivActivityLogViewModelGen) {
    this._activityLog = request;
  }

  @Mutation
  mutateDocuments(requests: MrfiktivActivityLogViewModelGen[]) {
    this._paginationList = requests;
  }

  @Action
  async create(data: { partnerId: string; data: MrfiktivCreateActivityLogDtoGen }) {
    const res = await activityLogService.create(data.partnerId, data.data);

    this.context.commit("mutateActivityLog", res);

    return res;
  }

  @Action
  async delete(data: { partnerId: string; documentId: string }) {
    const res = await activityLogService.removeForPartner(data.partnerId, data.documentId);

    this.context.commit("mutateActivityLog", res);

    return res;
  }

  @Action
  async getOne(data: { partnerId: string; documentId: string }) {
    const res = await activityLogService.getOneForPartner(data.partnerId, data.documentId);

    this.context.commit("mutateActivityLog", res);

    return res;
  }

  @Action
  async update(data: { partnerId: string; documentId: string; data: MrfiktivUpdateActivityLogDtoGen }) {
    const res = await activityLogService.updateForPartner(data.partnerId, data.documentId, data.data);

    this.context.commit("mutateActivityLog", res);

    return res;
  }
}

export const ActivityLogModule = getModule(ActivityLogStore);
